import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../../environments/environment";
import { RegistrationUser, ChangePasswordDto, ProfileEditInformation, EditUser } from "../../../models/user.model";
import { superAdminHttpRoutes, superAdminHttpVersion } from "../../../consts/super_admin_http_routes";
import { ApiService } from "../api.services";
import { portalHttpVersion } from "../../../consts/portal_http_routes";

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private url: string = superAdminHttpVersion.V1;
  private portalUrl: string = portalHttpVersion.V1;


  constructor(private apiService: ApiService, private _httpClient: HttpClient) {
  }

  filter(q: string, page_number?: number, page_size?: number, companyId?: string): Observable<any> {
    let params = new HttpParams();
    params = params.set('q', q);
    if (page_number) {
      params = params.set('page_number', page_number);
    }
    if (page_size) {
      params = params.set('page_size', page_size);
    }
    if (companyId) {
      params = params.set('companyId', companyId);
    }
    return this.apiService.httpGetCall(`${this.url}${superAdminHttpRoutes.USERS_GET_TABLE}`, params);
  }

  deactivate(userId: string): Observable<any> {
    return this.apiService.httpPatchCall(`${this.url}user/${userId}/status `, {
      "status": "Inactive"
    });
  }

  activate(userId: string): Observable<any> {
    return this.apiService.httpPatchCall(`${this.url}user/${userId}/status`, {
      "status": "Active"
    });
  }

  getCompanyList(): Observable<any> {
    return this.apiService.httpGetCallWithoutParameter(`${this.url}${superAdminHttpRoutes.COMPANY_ADD_EDIT}`);
  }

  register(user: RegistrationUser): Observable<any> {
    return this.apiService.httpPostCall(`${this.url}${superAdminHttpRoutes.USERS_ADD_EDIT}`, user)
  }

  updateUser(userId: string, user: EditUser): Observable<any> {
    return this.apiService.httpPutCall(`${this.url}${superAdminHttpRoutes.USERS_ADD_EDIT}/${userId}`, user)
  }

  updateUserProfile(userId: string, user: EditUser): Observable<any> {
    return this.apiService.httpPutCall(`${this.portalUrl}${superAdminHttpRoutes.USERS_ADD_EDIT}/${userId}`, user)
  }

  getProfile(id: string): Observable<any> {
    return this.apiService.httpGetCallWithoutParameter(`${this.portalUrl}user/${id}/profile`);
  }
  changePassword(id: string, changePasswordDto: ChangePasswordDto): Observable<any> {
    return this._httpClient.patch(`${this.url}/${id}/password`, changePasswordDto);
  }
  updateAvatar(id: string, form: FormData): Observable<any> {
    return this._httpClient.post(`${this.url}/${id}/avatar`, form);
  }

  deleteUser(id: string): Observable<any> {
    return this._httpClient.patch(`${this.url}/${id}/deactivate`, null);
  }
  activateUser(id: string): Observable<any> {
    return this._httpClient.patch(`${this.url}/${id}/activate`, null);
  }


    getSubscription(id: string,q: string, page_number?: number, page_size?: number): Observable<any> {
    let params = new HttpParams();
    params = params.set('q', q);
    if (page_number) {
      params = params.set('page_number', page_number);
    }
    if (page_size) {
      params = params.set('page_size', page_size);
    }
  
       return this.apiService.httpGetCall(`${this.url}subscription/user/${id}/subscriptions`, params);

  }

 getCompanySubscription(id: string, q: string, page_number?: number, page_size?: number, companyId?: string): Observable<any> {
  let params = new HttpParams().set('q', q);

  if (page_number) {
    params = params.set('page_number', page_number);
  }
  if (page_size) {
    params = params.set('page_size', page_size);
  }
  if (companyId) {
    params = params.set('companyId', companyId);
  }

  return this.apiService.httpGetCall(`${this.portalUrl}subscription/user/${id}/subscriptions`, params);
}

  uploadUserImage(file: File): Observable<any> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("bucketName", "sos-superadmin-portal");
    formData.append("dirPath", `users`);

    return this.apiService.httpPostCall<any>(
      `${this.portalUrl}${superAdminHttpRoutes.UPLOAD_PRODUCT_LOGO}`,
      formData
    );
  }

  sendMailToUser(userId: string) {
    return this.apiService.httpGetCallWithoutParameter(`${this.url}user/${userId}/send-invitation`);
  }


}
